import { useContext } from "react";
import { ProviderContext } from "@RequestFormV2/sections/Provider/context/ProviderProvider";

export function useProvider() {
  const context = useContext(ProviderContext);
  if (!context) {
    throw new Error("useProvider must be used within a ProviderProvider");
  }
  return context;
}
